import { iaRa } from 'lib/helpers/utility';
import { useRecurringAppointments } from 'lib/hooks/queries/appointment/useRecurringAppointments';
import useTimezone from 'lib/hooks/useTimezone';

import {
  usePaymentContext,
  usePaymentContextApi
} from 'components/Payments/NewPayment/PaymentContent/context/PaymentContext';
import Select from 'components/shared/Select/Select';

import {
  recurringAppointmentOptionLabel,
  recurringPaymentFromAppointment
} from '../../../../lib/helpers';

const LinkToAppointment = ({ patientId }) => {
  const timezone = useTimezone();
  const { values } = usePaymentContext();
  const { setFieldValue } = usePaymentContextApi();

  const recurringPayment = values?.recurringPayment;

  const { data } = useRecurringAppointments({
    params: { patientId },
    dependencies: [patientId],
    options: { enabled: Boolean(patientId) }
  });

  const appointments = iaRa(data?.appointments).map((appointment) => ({
    label: recurringAppointmentOptionLabel(appointment),
    value: appointment?.id,
    appointment
  }));

  const options = [{ label: 'None', value: null, appointment: null }, ...appointments];

  const currentAppointment = options.find(
    (option) => option.value === recurringPayment?.linkToRecurringAppointment
  );

  const handleChange = (option) => {
    if (!option?.appointment) {
      setFieldValue('recurringPayment', {
        ...recurringPayment,
        linkToRecurringAppointment: null
      });
      return;
    }
    setFieldValue(
      'recurringPayment',
      recurringPaymentFromAppointment(option.appointment, timezone, recurringPayment)
    );
  };

  return (
    <Select
      inputId="link-to-recurring-appointment"
      label="Link to a recurring appointment"
      value={currentAppointment}
      options={options}
      onChange={handleChange}
      name="linkToRecurringAppointment"
      parentClassName="flex-1"
      isClearable={false}
      menuPortalTarget={document.body}
    />
  );
};

export default LinkToAppointment;
